import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Link as MuiLink, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const HelpCenterLink = () => {
  const {
    t,
    i18n: { resolvedLanguage = 'en' },
  } = useTranslation()
  const langParam = resolvedLanguage === 'en' ? 'en-ca' : resolvedLanguage

  return (
    <MuiLink
      href={`https://help-admin.dialogue.co/hc/${langParam}`}
      target="_blank"
      sx={{
        color: 'secondary.main',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <HelpOutlineOutlinedIcon fontSize="small" />
      <Typography
        color="text.secondary"
        sx={{ fontWeight: 'normal', fontSize: 'medium', lineHeight: 1 }}
      >
        {t('applicationBar.helpCenter')}
      </Typography>
    </MuiLink>
  )
}
